<template>
  <div class="table">
    <ViewHeaderBar>
      <template #left></template>
      <template #right>
        <Button class="header-item btn" type="primary" @click="goToCreateTabelPage">
          {{ $t(`${createTableBtnText}`) }}
        </Button>
      </template>
    </ViewHeaderBar>
    <Table :loading="loading" :columns="recordsCol" :data="records"></Table>
  </div>
</template>

<script lang="jsx">
import nodeID from '@/mixins/nodeID'
import ViewHeaderBar from '@/components/ViewHeaderBar.vue'

import { loadTables, deleteTable } from '@/api/table'

export default {
  name: 'Tables',

  mixins: [nodeID],

  components: {
    ViewHeaderBar,
  },

  data() {
    return {
      loading: false,
      records: [],
      recordsCol: [
        {
          title: this.$t('common.name'),
          key: 'name',
          render: (h, params) => {
            return (
              <div>
                <a
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row, 'view')
                  }}
                >
                  {params.row.name}
                </a>
              </div>
            )
          },
        },
        {
          title: this.$t('common.operations'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return (
              <div>
                <a
                  style="margin-right: 10px;"
                  href="javascript:;"
                  onClick={() => {
                    this.showDetail(params.row, 'edit')
                  }}
                >
                  <Icon type="ios-create"></Icon>
                </a>
                <a href="javascript:;">
                  <Poptip
                    confirm={true}
                    transfer={true}
                    width={200}
                    title={this.$t('tables.deleteTableWarning')}
                    placement="top"
                    type="error"
                    vOn:on-ok={() => {
                      this.remove(params.row)
                    }}
                    vOn:on-cancel={() => {}}
                  >
                    <Icon type="md-trash"></Icon>
                  </Poptip>
                </a>
              </div>
            )
          },
        },
      ],
      createTableBtnText: 'tables.createTable',
      kind: 'scan', // differentiate `scan` table and `lookup` table
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.loading = true
      loadTables(this.nodeID, { kind: this.kind })
        .then((res) => {
          this.records = res.data.map((item) => ({ name: item }))
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    // create | edit | view table page
    goToDetailPage(oper, name) {
      const tableName = name || 0
      this.$router.push({
        name: 'tableDetails',
        params: {
          tableName,
        },
        query: {
          oper,
        },
      })
    },

    // create table page
    goToCreateTabelPage() {
      this.goToDetailPage('create')
    },

    // view | edit table
    showDetail({ name }, oper) {
      this.goToDetailPage(oper, name)
    },

    remove({ name }) {
      deleteTable(this.nodeID, name)
        .then((res) => {
          if (res.status === 200 && res.statusText === 'OK') {
            this.$Message.success(res.data)
          } else {
            this.$Message.success(this.$t('common.deleteSuccess'))
          }
          this.loadData()
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss"></style>
